import * as React from 'react';
import configData from "../config.json";

import { RouteComponentProps } from 'react-router';
import {
    Card, CardHeader, CardBody, Row, Col, FormGroup, Label, Input, CustomInput, InputGroup, InputGroupAddon,
    Button
} from 'reactstrap';

import Megafono from "assets/icons/megafono.png"
import CardInformacionFamiliar from "components/Varios/CardInformacionFamiliar.js";
import Icon from "components/Varios/Icons.js";
import SelectItem from "components/Varios/select.js";
import Datepicker from "components/Varios/Datepicker.js";
import TooltipItem from "components/Varios/Tooltip.js";
import { alertService } from 'components/Varios/alert_service.js';

import FileUpload from "components/Varios/FileUpload.js";
import FileDownload from "components/Varios/FileDownload.js";

import InputFileDownload from "components/Varios/InputFileDownload.js";
import InputFileUpload from "components/Varios/InputFileUpload.js";

import { authenticationService } from '../services/authentication.service';
import { mensajeCamposIncompletos } from './constants';

const API_URL = configData.SERVER_URL

export const MensajeEncabezadoCargasFamiliares = <p style={{ textAlign: "justify" }}>
    <br />
    Se considerarán como cargas familiares a los padres, cónyuge o pareja en unión
    de hecho e hijos hasta los 21 años o con discapacidad de cualquier edad, <strong> siempre
        que no perciban ingresos gravados y que sean dependientes del sujeto pasivo</strong>. <br />
    La documentación que acredite las cargas familiares del trabajador deberá ser
    entregada al empleador que actúe como agente de retención: <br />
    &nbsp;&nbsp; a) Copia de la cédula de identidad del cónyuge o pareja en unión de hecho
    dependiente del trabajador donde se evidencie el parentesco. <br />
    &nbsp;&nbsp; b) Copia de la cédula de identidad de los hijos sin discapacidad de hasta 21 años
    de edad dependientes del trabajador donde se evidencie el parentesco. <br />
    &nbsp;&nbsp; c) Copia de la cédula de identidad y del carnet de discapacidad emitido por la
    autoridad competente, de los hijos con discapacidad dependientes del
    trabajador donde se evidencie el parentesco. <br />
    &nbsp;&nbsp; d) Copia del certificado o aval de padecer una enfermedad catastrófica, rara y/o
    huérfana emitido por el Ministerio de Salud Pública o el Instituto
    Ecuatoriano de Seguridad Social a nombre del trabajador o de su carga
    familiar, según corresponda. <br />
    &nbsp;&nbsp; e) Para el registro de padres como cargas familiares, deberán prestar su
    consentimiento expreso para ser incluidos como carga familiar del
    contribuyente y presentar copia de la cédula de identidad donde se evidencie
    el parentesco.
    <br />
</p>

export const tiposIdentificacion = [
    { label: 'Cédula', value: "CED" },
    { label: 'Pasaporte', value: "PAS" },
];

const tiposDiscapacidades = {
    "LENGUAJE": "5",
    "PSICOLOGICO": "6",
    "PSICOSOCIAL": "7",
    "AUDITIVA": "1",
    "FISICA": "2",
    "INTELECTUAL": "3",
    "VISUAL": "4"
}

const tipoCargasFamiliares = [1, 2, 14, 20, 22];

export class InformacionFamiliarData {
    idpersona: number = 0;
    iddependientepersona: number = 0;
    apellidos: string = "";
    nombres: string = "";
    fechanacimiento: string = "";
    numeroidentificacion: string = "";
    tipoidentificacion: string = "CED";
    idparentesco: number = 0;
    idcatalnivelinstruccion: number = 0;
    esincapacitado: string = "N";
    discapporc: number = 0;
    discaptipo: string = "";
    strNombreParentesco: string = "";
    strNivelInstruccion: string = "";
    strNombreTipoDiscapacidad: string = "";
    discapcarnet: string|null = "";
    fechaemisiondiscap?: string|null = "";
    fechacaducidaddiscap?: string|null = "";
    estudiaencopol: string = "N";
    essustitutolegal: string = "N";
    esdifunto: string = "N";
    parentesco: string = "--";
    sexo: string = "";
    refarchivo: string = "";
    refarchivodoc1: string = "";
    refarchivodoc2: string = "";
    refarchivodoc3: string = "";
    refarchivodoc4: string = "";
    refarchivodoc5: string = "";
    fechaemisioncertsustituto?: string = "";
    fechacaducidadcertsustituto?: string = "";
    numerocertsustituto: string = "";
    estadorevisionth: number = -1;
    servidoringreso: string = "NO";
    fechacaducidad: string = "";
    considerargp: string = "N";
    refarchivoconsentimiento: string = "";
    tieneenfercatastrofica: string = "N";
    refarchivoenfercatastrofica: string = "";
}

interface InformacionFamiliarDataState {
    currentUser: any;
    loading: boolean;
    loadingList: boolean;
    dtoData: InformacionFamiliarData;
    InformacionFamiliarDataList: InformacionFamiliarData[];
    parentescoList: Array<any>;
    sexoList: Array<any>;
    nivelInstruccionList: Array<any>;
    tipoDiscapacidadList: Array<any>;
    error: null,
    tiposEvidencia: Array<any>;
    filesData: Array<any>;
    declaracionVeracidad: boolean;
    autorizacion: boolean;
    readOnlyDatos: boolean;
    webServiceFuncional: boolean;
}

export class InformacionFamiliar extends React.Component<RouteComponentProps<{}>, InformacionFamiliarDataState> {
    constructor(props) {
        super(props);
        this.state = {
            currentUser: authenticationService.currentUserValue, loading: true, loadingList: true,
            dtoData: new InformacionFamiliarData(), InformacionFamiliarDataList: [], parentescoList: [], sexoList: [], nivelInstruccionList: [],
            tipoDiscapacidadList: [], error: null, tiposEvidencia: [], filesData: [], declaracionVeracidad: false,
            autorizacion: true, readOnlyDatos: false, webServiceFuncional: true
        };

        // This binding is necessary to make "this" work in the callback
        this.cargarDatos = this.cargarDatos.bind(this);
        this.cargarInformacionFamiliar = this.cargarInformacionFamiliar.bind(this);
        this.buscarPersona = this.buscarPersona.bind(this);
        this.buscarPersonaDiscapacidad = this.buscarPersonaDiscapacidad.bind(this);
        //this.onClickEdit = this.onClickEdit.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.toggleCheckbox = this.toggleCheckbox.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleFileUploadChange = this.handleFileUploadChange.bind(this);
    }

    componentDidMount() {
        authenticationService.currentUser.subscribe(
            (x) => {
                this.setState({
                    currentUser: x
                });
                if (x && x.token) {
                    this.cargarDatos();
                    this.cargarInformacionFamiliar();
                }
            }
        );
    }

    componentWillUnmount() {
        alertService.clear();
    }

    cargarDatos() {
        //API PARA OBTENER PARENTESCO
        fetch(API_URL + "DatosContactoEmergencia/ContactoEmergenciaParentesco")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            parentescoList: result.entTabla.map(d => ({
                                "value": d.idparentesco,
                                "label": d.nombre
                            })),
                            loading: false
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los parentescos.")
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        parentescoList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        // API PARA OBTENER SEXOS
        fetch(API_URL + "DatosGenerales/Sexo")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            sexoList: result.entTabla.map(d => ({
                                "value": d.codigostr.trim(),
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los sexos.")
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        sexoList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        // API PARA OBTENER NIVEL DE INSTRUCCIÓN
        fetch(API_URL + "InformacionFamiliar/NivelInstruccion")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            nivelInstruccionList: result.entTabla.map(d => ({
                                "value": d.codigo,
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los niveles de instrucción.")
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        nivelInstruccionList: []
                    });
                    alertService.error("Ocurrió un error: " + error)
                }
            )

        //API PARA OBTENER TIPOS DE DISCAPACIDAD
        fetch(API_URL + "DatosSalud/TipoDiscapacidad")
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            tipoDiscapacidadList: result.entTabla.map(d => ({
                                "value": d.codigo.toString(),
                                "label": d.descripcion
                            })),
                        });
                    } else {
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener los tipos de discapacidad.")
                    }
                },
                (error) => {
                    this.setState({
                        error,
                        tipoDiscapacidadList: []
                    });
                    alertService.error("Ocurrió un error.")
                }
            )
    }

    cargarInformacionFamiliar() {
        //API PARA OBTENER FAMILIARES DE PERSONA
        fetch(API_URL + "InformacionFamiliar/InformacionFamiliarByIdPersonaDesc/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            InformacionFamiliarDataList: result.entTabla,
                            loading: false,
                            loadingList: false
                        });
                    } else {
                        this.setState({
                            loadingList: false
                        });
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener la información familiar.")
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        InformacionFamiliarDataList: []
                    });
                    alertService.error("Ocurrió un error.")
                }
            )
    }

    onClickEdit(iddependientepersona) {
        this.setState({
            dtoData: new InformacionFamiliarData()
        });

        //API PARA OBTENER TELEFONOS DE PERSONA
        fetch(API_URL + "InformacionFamiliar/InformacionFamiliarById/" + iddependientepersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        let filesData = this.state.filesData;

                        this.setState({
                            dtoData: result.entTabla[0],
                            tiposEvidencia: this.cargarEvidencias(result.entTabla[0].esincapacitado, result.entTabla[0].essustitutolegal, result.entTabla[0].considerargp, result.entTabla[0].tieneenfercatastrofica, filesData),
                            loading: false
                        });

                        this.buscarPersonaDiscapacidad(result.entTabla[0].numeroidentificacion);

                        let myDiv = document.getElementById('main-panel')!;
                        myDiv.scrollTo(0, 0);
                    } else {
                        alertService.error(result["strMensaje"])
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        dtoData: new InformacionFamiliarData()
                    });
                    alertService.error("Ocurrió un error")
                }
            )
    }

    onClickDelete(iddependientepersona) {
        //API PARA OBTENER TELEFONOS DE PERSONA
        fetch(API_URL + "FormularioController/DeleteDatosInformacionFamiliar/" + iddependientepersona, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
        })
            .then(response => response.json())
            .then(
                (responseJson) => {
                    if (responseJson["strEstado"] === "N") {
                        alertService.error(responseJson["strMensaje"])
                    }
                    else {
                        alertService.success("La información familiar se eliminó correctamente");
                        this.cargarFamiliares();
                    }
                })
    }

    onClickLimpiar() {
        var a = "";
        this.setState({
            dtoData: new InformacionFamiliarData(),
            declaracionVeracidad: false,
            autorizacion: false,
            filesData: [],
        });
    }

    cargarFamiliares() {
        fetch(API_URL + "InformacionFamiliar/InformacionFamiliarByIdPersonaDesc/" + this.state.currentUser.idpersona)
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.strEstado === "S") {
                        this.setState({
                            InformacionFamiliarDataList: result.entTabla,
                            loading: false,
                            loadingList: false
                        });
                    } else {
                        this.setState({
                            loadingList: false
                        });
                        //console.log(result["strMensaje"])
                        alertService.error("Ocurrió un error al obtener la información familiar.")
                    }
                },
                (error) => {
                    this.setState({
                        loading: false,
                        error,
                        InformacionFamiliarDataList: []
                    });
                    alertService.error("Ocurrió un error.")
                }
            )
    }

    cargarEvidencias(tieneDiscapacidad, esSustituto, considerargp, tieneenfercatastrofica, filesData: any[]) {
        var tiposEvidencia = [{ "value": "PAR", "label": "Cédula del familiar" + filesData.filter(f => f.type === "CED").map(ff => ': ' + ff.file.name).join(', ') }];
        if (considerargp === "S") {
            tiposEvidencia.push({ "value": "CCF", "label": "Consentimiento expreso para ser incluidos como carga familiar" + filesData.filter(f => f.type === "CCF").map(ff => ': ' + ff.file.name).join(', ') });
        }
        if (tieneenfercatastrofica === "S") {
            tiposEvidencia.push({ "value": "ENC", "label": "Certificado o aval de padecer una enfermedad catastrófica, rara y/o huérfana" + filesData.filter(f => f.type === "ENC").map(ff => ': ' + ff.file.name).join(', ') });
        }
        if (tieneDiscapacidad === "S") {
            tiposEvidencia.push({ "value": "FDS", "label": "Carnet CONADIS" + filesData.filter(f => f.type === "CED").map(ff => ': ' + ff.file.name).join(', ') });
        }

        if (esSustituto === "S") {
            //tiposEvidencia.push({ "value": "MSP", "label": "Ministerio de Salud" + filesData.filter(f => f.type === "CED").map(ff => ': ' + ff.file.name).join(', ') });
            //tiposEvidencia.push({ "value": "MIE", "label": "MIES" + filesData.filter(f => f.type === "CED").map(ff => ': ' + ff.file.name).join(', ') });
            tiposEvidencia.push({ "value": "TRA", "label": "Ministerio de Trabajo" + filesData.filter(f => f.type === "CED").map(ff => ': ' + ff.file.name).join(', ') });
            //tiposEvidencia.push({ "value": "DJT", "label": "Declaración Juramentada" + filesData.filter(f => f.type === "CED").map(ff => ': ' + ff.file.name).join(', ') });
        }
        return tiposEvidencia;
    }

    descargarEvidencias(informacionFamiliar: InformacionFamiliarData) {
        var evidencias = new Array();

        if (informacionFamiliar.refarchivo) {
            evidencias.push({ name: "DE-" + informacionFamiliar.numeroidentificacion + ".PDF", url: API_URL + "InformacionFamiliar/Refarchivo/FDS/" + informacionFamiliar.iddependientepersona });
        }
        if (informacionFamiliar.refarchivodoc1) {
            evidencias.push({ name: "DOCUMENTO-" + informacionFamiliar.numeroidentificacion + ".PDF", url: API_URL + "InformacionFamiliar/Refarchivo/PAR/" + informacionFamiliar.iddependientepersona });
        }
        //if (informacionFamiliar.refarchivodoc2) {
        //    evidencias.push({ name: "DE" + informacionFamiliar.numeroidentificacion + ".PDF", url: API_URL + "InformacionFamiliar/Refarchivo/MSP/" + informacionFamiliar.iddependientepersona });
        //}
        //if (informacionFamiliar.refarchivodoc3) {
        //    evidencias.push({ name: "DE" + informacionFamiliar.numeroidentificacion + ".PDF", url: API_URL + "InformacionFamiliar/Refarchivo/MIE/" + informacionFamiliar.iddependientepersona });
        //}
        if (informacionFamiliar.refarchivodoc4) {
            evidencias.push({ name: "DE" + informacionFamiliar.numeroidentificacion + ".PDF", url: API_URL + "InformacionFamiliar/Refarchivo/TRA/" + informacionFamiliar.iddependientepersona });
        }
        //if (informacionFamiliar.refarchivodoc5) {
        //    evidencias.push({ name: "DE" + informacionFamiliar.numeroidentificacion + ".PDF", url: API_URL + "InformacionFamiliar/Refarchivo/DJT/" + informacionFamiliar.iddependientepersona });
        //}
        if (informacionFamiliar.refarchivoconsentimiento) {
            evidencias.push({ name: "DOCUMENTO-" + informacionFamiliar.numeroidentificacion + ".PDF", url: API_URL + "InformacionFamiliar/Refarchivo/CCF/" + informacionFamiliar.iddependientepersona });
        }
        if (informacionFamiliar.refarchivoenfercatastrofica) {
            evidencias.push({ name: "DOCUMENTO-" + informacionFamiliar.numeroidentificacion + ".PDF", url: API_URL + "InformacionFamiliar/Refarchivo/ENC/" + informacionFamiliar.iddependientepersona });
        }
        return evidencias;
    }

    handleFileUploadChange(tipoEvidencia, uploadFile) {
        const src = window.URL.createObjectURL(uploadFile);
        const fileInfo = { type: tipoEvidencia, file: uploadFile, id: tipoEvidencia, src: src };
        let fileInfoState = this.state.filesData.slice();
        let fileInfoStateFiltrado = fileInfoState.filter(f => f.type !== fileInfo.type);
        fileInfoState = fileInfoStateFiltrado.concat(fileInfo);
        var dto = this.state.dtoData;
        this.setState({
            filesData: fileInfoState,
            tiposEvidencia: this.cargarEvidencias(dto.esincapacitado, dto.essustitutolegal, dto.considerargp, dto.tieneenfercatastrofica, fileInfoState)
        });
    }

    handleSelectChange(value, name) {
        var dto = this.state.dtoData;
        dto[name] = value;
        if (name === "tipoidentificacion") {
            //if (this.state.dtoData.tipoidentificacion === "CED" && this.state.dtoData.numeroidentificacion && this.state.dtoData.numeroidentificacion.length === 10 && this.state.dtoData.idpersona === 0) {
            if (this.state.dtoData.tipoidentificacion === "CED" && this.state.dtoData.numeroidentificacion && this.state.dtoData.numeroidentificacion.length === 10) {
                this.buscarPersona(this.state.dtoData.numeroidentificacion);
            }
            else if (this.state.dtoData.tipoidentificacion === "PAS") {
                dto.nombres = ""
                dto.apellidos = ""
                dto.sexo = ""
                dto.fechanacimiento = ""
                this.setState({
                    readOnlyDatos: false
                });
            }
            else {
                this.setState({
                    readOnlyDatos: false
                });
            }
        }
        else {
            this.setState({
                readOnlyDatos: false
            });
        }

        this.setState({ dtoData: dto });
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        var dto = this.state.dtoData;
        dto[name] = value;

        this.setState({ dtoData: dto });
    }

    toggleCheckbox(event) {
        //console.log(this.state)
        //console.log(event.target)
        if (event.target.name === "autorizacion") {
            this.setState(
                {
                    autorizacion: !this.state.autorizacion,
                }
            );
        }
        if (event.target.name === "declaracionVeracidad") {
            this.setState(
                {
                    declaracionVeracidad: !this.state.declaracionVeracidad,
                }
            );
        }
    }

    private handleSave(event, estadoComponente: InformacionFamiliarDataState) {
        event.preventDefault();
        const forma = new FormData(event.target);
        var dto = { ...this.state.dtoData };
        var filesData = this.state.filesData;
        let formIsValid = true;

        if (dto['esincapacitado'] === 'S') {
            //if (dto['fechaemisiondiscap'] >= dto['fechacaducidaddiscap']) {
            //    alertService.error("Error: La fecha de caducidad debe ser mayor a la fecha de emisión.");
            //    return;
            //}
            if (dto['essustitutolegal'] === 'S') {
                if (dto['fechaemisioncertsustituto'] && dto['fechacaducidadcertsustituto'] &&  dto['fechaemisioncertsustituto'] >= dto['fechacaducidadcertsustituto']) {
                    alertService.error("Error: La fecha de caducidad debe ser mayor a la fecha de emisión.");
                    return;
                }
                // if (!this.state.declaracionVeracidad) {
                //     alertService.error("Error: Por favor marque la declaración de veracidad.");
                //     return;
                // }
            }
            if (!estadoComponente.autorizacion) {
                alertService.error("Error: Por favor marque el acuerdo de responsabilidad de datos de la parte inferior.");
                return;
            }

            if (this.state.webServiceFuncional) {
                dto["servidoringreso"] = "NO"
                dto["estadorevisionth"] = 2
            }
            else {
                dto["servidoringreso"] = "SI"
                dto["estadorevisionth"] = 1
            }
        }

        if (filesData.length === 0 && !dto.refarchivodoc1) {
            alertService.error("Debe ingresar la identificación del familiar.");
            return;
        }
        if (filesData.length > 0 && !dto.refarchivodoc1) {
            filesData.map((fileData) => {
                if (fileData.type == "CED" && !fileData.file) {
                    alertService.error("Debe ingresar la identificación del familiar.");
                    return;
                }
            });
        }

        if ((dto.idparentesco == 1 || dto.idparentesco == 2) && dto.considerargp == "S") {
            if (filesData.length === 0 && !dto.refarchivoconsentimiento) {
                alertService.error("Debe ingresar el consentimiento expreso para ser incluidos como carga familiar.");
                return;
            }
            if (filesData.length > 0 && !dto.refarchivoconsentimiento) {
                filesData.map((fileData) => {
                    if (fileData.type == "CCF" && !fileData.file) {
                        alertService.error("Debe ingresar el certificado o aval de padecer una enfermedad catastrófica, rara y/o huérfana.");
                        return;
                    }
                });
            }
        }

        if (dto.tieneenfercatastrofica == "S") {
            if (filesData.length === 0 && !dto.refarchivoenfercatastrofica) {
                alertService.error("Debe ingresar el certificado o aval de padecer una enfermedad catastrófica, rara y/o huérfana.");
                return;
            }
            if (filesData.length > 0 && !dto.refarchivoenfercatastrofica) {
                filesData.map((fileData) => {
                    if (fileData.type == "ENC" && !fileData.file) {
                        alertService.error("Debe ingresar el certificado o aval de padecer una enfermedad catastrófica, rara y/o huérfana.");
                        return;
                    }
                });
            }
        }

        forma.forEach((value, clave) => {
            if (!value && clave !== "evidencias") {
                formIsValid = false;
            }

            //if (clave === 'discapporc') //console.log("clave=" + clave + " value=" + value + " typeof = " + (typeof (dto[clave]) === 'number' ? 'true' : 'false'));
            if (typeof dto[clave] === 'number') {
                dto[clave] = Number(value);
            }
            else if (typeof dto[clave] === 'boolean') {
                dto[clave] = Boolean(value);
            }
            else
                dto[clave] = value;

            if (clave === 'fechanacimiento' || clave === 'fechaemisiondiscap' || clave === 'fechacaducidaddiscap'
                || clave === 'fechaemisioncertsustituto' || clave === 'fechacaducidadcertsustituto' || clave === 'fechacaducidad') {
                value = String(value)
                var info = value.split('/').reverse().join('-');
                var date = new Date(String(info))
                dto[clave] = date.toJSON();
            }

            if (clave === 'discapporc') dto[clave] = Number(value);
        });

        //console.log(dto['fechanacimiento'])

        if (dto.tipoidentificacion === "CED") {
            var value = String(dto['fechanacimiento'])
            var info = value.split('/').join('-');
            var date = new Date(String(info))
            dto['fechanacimiento'] = date.toJSON();

            var value = String(dto['fechaemisiondiscap'])
            var info = value.split('/').join('-');
            var date = new Date(String(info))
            dto['fechaemisiondiscap'] = date.toJSON();
        }

        if (dto.discapporc) {
            dto.discapporc = Number(dto.discapporc);
        }

        if (dto.esincapacitado === "N") {
            delete dto['fechaemisiondiscap'];
            delete dto['fechacaducidaddiscap'];
            delete dto['fechaemisioncertsustituto'];
            delete dto['fechacaducidadcertsustituto'];
        }
        else {
            if (!dto['fechaemisiondiscap']) delete dto['fechaemisiondiscap'];
            if (!dto['fechacaducidaddiscap']) delete dto['fechacaducidaddiscap'];
            if (!dto['fechaemisioncertsustituto']) delete dto['fechaemisioncertsustituto'];
            if (!dto['fechacaducidadcertsustituto']) delete dto['fechacaducidadcertsustituto'];
        }

        dto['parentesco'] = "--"
        dto['estado'] = "A"

        dto.idpersona = this.state.currentUser.idpersona;

        const data = JSON.stringify({
            "tdependientepersona": dto
        });

        if (formIsValid) {
            if (dto.iddependientepersona === 0) {
                fetch(API_URL + "FormularioController/PostDatosInformacionFamiliar", {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,
                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                //alertService.error(mensajeCamposIncompletos())
                                alertService.error(responseJson["strMensaje"])
                            }
                            else if (responseJson["strEstado"] === "S") {

                                authenticationService.updateUltimoCambioCurrentUserValue(new Date().toISOString())

                                if (filesData.length > 0) {
                                    var formFilesData = new FormData();

                                    filesData.map((fileData) => {
                                        formFilesData.append(fileData.type, fileData.file, fileData.file.name);
                                    });

                                    formFilesData.append('iddependientepersona', responseJson.tdependientepersona.iddependientepersona);

                                    fetch(API_URL + "FormularioController/PostFilesDatosInformacionFamiliar", {
                                        method: 'POST',
                                        body: formFilesData
                                    })
                                        .then(response => response.json())
                                        .then(
                                            (responseJson) => {
                                                if (responseJson["strEstado"] === "S") {
                                                    alertService.success("La información familiar se ha registrado correctamente.")
                                                    this.onClickLimpiar();
                                                    this.cargarFamiliares();
                                                }
                                                else {
                                                    alertService.error(responseJson["strMensaje"])
                                                }
                                            })
                                        .catch(error => alertService.error(error)
                                        );
                                }
                                else {
                                    alertService.success("La información familiar se ha registrado correctamente.")
                                    this.onClickLimpiar();
                                    this.cargarFamiliares();
                                }
                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }
                        },
                        (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        })
                    .catch(function (err) {
                        alertService.error("Ocurrió un error: " + err)
                    });
            }
            else {
                fetch(API_URL + "FormularioController/PutDatosInformacionFamiliar", {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: data,
                })
                    .then(response => response.json())
                    .then(
                        (responseJson) => {
                            if (responseJson["strEstado"] === "N") {
                                alertService.error(responseJson["strMensaje"])
                            }
                            else if (responseJson["strEstado"] === "S") {

                                authenticationService.updateUltimoCambioCurrentUserValue(new Date().toISOString())

                                if (filesData.length > 0) {
                                    var formFilesData = new FormData();

                                    filesData.map((fileData) => {
                                        formFilesData.append(fileData.type, fileData.file, fileData.file.name);
                                    });

                                    formFilesData.append('iddependientepersona', responseJson.tdependientepersona.iddependientepersona);

                                    fetch(API_URL + "FormularioController/PostFilesDatosInformacionFamiliar", {
                                        method: 'POST',
                                        body: formFilesData
                                    })
                                        .then(response => response.json())
                                        .then(
                                            (responseJson) => {
                                                if (responseJson["strEstado"] === "S") {
                                                    alertService.success("La información familiar se ha actualizado correctamente.")
                                                    this.onClickLimpiar();
                                                    this.cargarFamiliares();
                                                }
                                                else {
                                                    alertService.error(responseJson["strMensaje"])
                                                }
                                            })
                                        .catch(error => alertService.error(error)
                                        );
                                }
                                else {
                                    alertService.success("La información familiar se ha actualizado correctamente.")
                                    this.onClickLimpiar();
                                    this.cargarFamiliares();
                                }
                            }
                            else {
                                alertService.error("Ocurrió un error: " + responseJson)
                            }
                        },
                        (error) => {
                            alertService.error("Ocurrió un error: " + error)
                        })
                    .catch(function (err) {
                        alertService.error("Ocurrió un error: " + err)
                    });
            }
        } else {
            alertService.error("Ocurrió un error: por favor complete la información de todos los campos obligatorios (*).");
        }
    }

    // This will handle Cancel button click event.

    private handleCancel(e) {
        e.preventDefault();

        this.props.history.push("/fetch-contactos");
    }

    handleChange(event) {
        var dto = this.state.dtoData;
        var filesData = this.state.filesData;
        dto[event.target.name] = event.target.value

        if (event.target.name === "numeroidentificacion") {
            dto[event.target.name] = event.target.value.substring(0, 10);
        }

        this.setState({
            dtoData: dto,
            tiposEvidencia: this.cargarEvidencias(dto.esincapacitado, dto.essustitutolegal, dto.considerargp, dto.tieneenfercatastrofica, filesData),
        })

        if (event.target.name === "numeroidentificacion" || event.target.name === "tipoidentificacion") {
            if (this.state.dtoData.tipoidentificacion === "CED" && this.state.dtoData.numeroidentificacion && this.state.dtoData.numeroidentificacion.length === 10) {
                this.buscarPersona(this.state.dtoData.numeroidentificacion);
            }
            else {
                this.setState({
                    readOnlyDatos: false
                });
            }
        }
        else {
            this.setState({
                readOnlyDatos: false
            });
        }

        //if (event.target.value === 'S') {
        //    tieneDiscapacidad = true;
        //}
        //else {
        //    tieneDiscapacidad = false;
        //    Array.from(document.querySelectorAll("input")).forEach(
        //        input => (input.value = "")
        //    );
        //}
    }

    buscarPersona(identificacion) {
        var dto = this.state.dtoData
        if (dto.tipoidentificacion === "CED" && dto.numeroidentificacion && dto.numeroidentificacion.length === 10) {
            fetch(API_URL + "DatosGenerales/Ciudadano/" + identificacion)
                .then(res => res.json())
                .then(
                    (result) => {
                        if (result.strEstado === "S") {
                            if (result.entTabla[0].nombre) {
                                var dto = this.state.dtoData
                                //console.log(result.entTabla[0].error)
                                if (result.entTabla[0].nombrePadre && result.entTabla[0].nombreMadre && result.entTabla[0].nombre) {
                                    //console.log("entra")
                                    const { nombre, apellido, apellido2 } = this.getNombresCompletos(result.entTabla[0].nombrePadre, result.entTabla[0].nombreMadre, result.entTabla[0].nombre);

                                    dto.nombres = nombre;
                                    dto.apellidos = apellido + " " + apellido2;
                                }

                                if (result.entTabla[0].fechaNacimiento) {
                                    var info = result.entTabla[0].fechaNacimiento.split('/');
                                    var date = info[2] + "/" + info[1] + "/" + info[0]
                                    dto.fechanacimiento = date
                                }

                                dto.sexo = (result.entTabla[0].sexo === "MUJER" ? "F" : "M")

                                this.setState({
                                    dtoData: dto,
                                    readOnlyDatos: true
                                });
                            }
                        } else {
                            //console.log(result["strMensaje"])
                            alertService.error("Ocurrió un error al obtener información del ciudadano.")
                        }
                        this.buscarPersonaDiscapacidad(identificacion);
                    },
                    (error) => {
                        this.setState({
                            readOnlyDatos: false
                        });
                        alertService.error("Ocurrió un error: " + error)
                    }
                )

            
        }
    }

    buscarPersonaDiscapacidad(identificacion) {
        var dto = {...this.state.dtoData}
        if (dto.tipoidentificacion === "CED" && dto.numeroidentificacion && dto.numeroidentificacion.length === 10) {
            fetch(API_URL + "DatosGenerales/Discapacidad/" + identificacion)
                .then(res => res.json())
                .then(
                    (result) => {
                        //console.log(result)
                        if (result.strEstado === "S") {
                            if (result.entTabla[0].nombres) {


                                dto.discapcarnet = result.entTabla[0].codigoConadis
                                dto.discapporc = result.entTabla[0].porcentajeDiscapacidad
                                dto.discaptipo = tiposDiscapacidades[result.entTabla[0].deficienciaPredomina]

                                if (dto.discapcarnet !== null) {
                                    dto.esincapacitado = "S"
                                }
                                else {
                                    dto.esincapacitado = "N"
                                }

                                if (result.entTabla[0].fechaConadis && result.entTabla[0].fechaConadis) {
                                    var info = result.entTabla[0].fechaConadis.split(' ')[0].split('/');
                                    var date = info[2] + "/" + info[1] + "/" + info[0]
                                    dto.fechaemisiondiscap = date
                                }

                                this.setState({
                                    dtoData: dto,
                                    webServiceFuncional: true
                                });
                            }
                        } else {
                            //console.log(result["strMensaje"])
                            alertService.error("Ocurrió un inconveniente al obtener información de Discapacidad del Ministerio de Salud.Por favor, ingrese su información manualmente.")
                            this.setState({
                                webServiceFuncional: false
                            })
                        }
                    },
                    (error) => {
                        this.setState({
                            readOnlyDatos: false
                        });
                        alertService.error("Ocurrió un error: " + error)
                    }
                )
        }
    }

    getNombresCompletos(nombre_padre, nombre_madre, nombre: string) {
        var nombres = "";
        var apellido_padre = "";
        var apellido_madre = "";

        var padre_list: string[] = nombre_padre.trim().split(' ');
        var madre_list: string[] = nombre_madre.trim().split(' ');
        var nombres_list = nombre.trim().split(' ');

        //var herencia_padre_tmp = padre_list.map(i => i.toString()).intersect(nombres_list);
        //var herencia_madre_tmp = madre_list.map(i => i.toString()).intersect(nombres_list);

        var herencia_padre_tmp = padre_list.filter(x => nombres_list.includes(x.toString()));
        var herencia_madre_tmp = madre_list.filter(x => nombres_list.includes(x.toString()));

        var herencia_padre_array = herencia_padre_tmp;
        var herencia_madre_array = herencia_madre_tmp;

        if (herencia_padre_tmp.length === 0 && herencia_madre_tmp.length > 0) {
            const indiceApellidoMadre = nombre.indexOf(herencia_madre_tmp[0]);
            padre_list = nombre.slice(0, indiceApellidoMadre).trim().split(' ');
            herencia_padre_array = padre_list;

            if (herencia_padre_array.length > 0 && herencia_padre_array[0] === "") {
                const division_nombres: string[] = nombre.split(" ");
                var nombres_input: string = ""
                var apellido: string
                var apellido2: string

                if (division_nombres.length === 4) {
                    division_nombres.slice(2, undefined).forEach(n => {
                        nombres_input += n + " ";
                    });
                    apellido = division_nombres[0];
                    apellido2 = division_nombres[1];

                    return {
                        nombre: nombres_input,
                        apellido: apellido,
                        apellido2: apellido2
                    };
                }
            }
        }

        if (herencia_padre_array.length === 0 && herencia_madre_array.length === 0) {
            const division_nombres: string[] = nombre.split(" ");
            var nombres_input: string = ""
            var apellido: string
            var apellido2: string

            if (division_nombres.length === 4) {
                division_nombres.slice(2, undefined).forEach(n => {
                    nombres_input += n + " ";
                });
                apellido = division_nombres[0];
                apellido2 = division_nombres[1];

                return {
                    nombre: nombres_input,
                    apellido: apellido,
                    apellido2: apellido2
                };
            }
            else if (division_nombres.length === 5) {
                division_nombres.slice(3, undefined).forEach(n => {
                    nombres_input += n + " ";
                });
                apellido = division_nombres[0];
                apellido2 = division_nombres[1] + " " + division_nombres[2];

                return {
                    nombre: nombres_input,
                    apellido: apellido,
                    apellido2: apellido2
                };
            }
        }

        var herencia_padre: any[] = [];
        var herencia_madre: any[] = [];

        //Obtenemos el primer apellido
        var primer_apellido = "";
        if (herencia_padre_array.length > 0) {
            primer_apellido = padre_list[0];
        }
        else {
            primer_apellido = madre_list[0];
        }

        //APELLIDOS NOMBRES
        if (nombre.indexOf(primer_apellido) === 0) {
            var i_tmp = 0;
            //Limpiamos la herencia del padre
            herencia_padre = [];
            i_tmp = 0;
            for (let i = 0; i < herencia_padre_array.length; i++) {
                if (padre_list.indexOf(herencia_padre_array[i]) === i_tmp) {
                    herencia_padre.push(herencia_padre_array[i]);
                    i_tmp++;
                }
            }

            //Limpiamos la herencia del madre
            var i_tmp = 0;
            herencia_madre = [];
            i_tmp = 0;
            for (let i = 0; i < herencia_madre_array.length; i++) {
                if (madre_list.indexOf(herencia_madre_array[i]) === i_tmp) {
                    herencia_madre.push(herencia_madre_array[i]);
                    i_tmp++;
                }
            }
        }
        else {
            //Limpiamos la herencia del padre
            herencia_padre = [];
            var pos_ap = 0;
            for (let i = 0; i < herencia_padre_array.length; i++) {
                if (nombres_list.indexOf(herencia_padre_array[i]) === pos_ap) {
                    herencia_padre.push(herencia_padre_array[i]);
                    pos_ap++;
                }
            }

            //Limpiamos la herencia del madre
            herencia_madre = [];
            for (let i = 0; i < herencia_madre_array.length; i++) {
                if (nombres_list.indexOf(herencia_madre_array[i]) === pos_ap) {
                    herencia_madre.push(herencia_madre_array[i]);
                    pos_ap++;
                }
            }
        }

        herencia_padre.forEach(i_padre => {
            apellido_padre += i_padre + " ";
        }
        );

        apellido_padre = apellido_padre.trim();

        //Obtenemos el apellido de la madre
        herencia_madre.forEach(i_madre => {
            apellido_madre += i_madre + " ";
        }
        );

        apellido_madre = apellido_madre.trim();

        try {
            if (apellido_padre != "") {
                nombres = nombre.trim().replace(apellido_padre, "");
            }
            else {
                nombres = nombre;
            }

            if (apellido_madre != "") {
                nombres = nombres.replace(apellido_madre, "");
            }
            nombres = nombres.trim();
        }
        catch
        {
            nombres = "";
            apellido_padre = "";
            apellido_madre = "";
        }

        return {
            nombre: nombres,
            apellido: apellido_padre,
            apellido2: apellido_madre
        };
    }

    public render() {
        let contents = this.state.loading

            ?
            <div style={{ textAlign: "center" }}>
                <i className="fas fa-sync fa-spin"></i>
                <em> Cargando</em>
            </div>

            : this.renderForm(this.state.InformacionFamiliarDataList, this.state.parentescoList, this.state.sexoList, this.state.nivelInstruccionList, this.state.tipoDiscapacidadList, this.cargarEvidencias(this.state.dtoData.esincapacitado, this.state.dtoData.essustitutolegal, this.state.dtoData.considerargp, this.state.dtoData.tieneenfercatastrofica, this.state.filesData), this.state);

        return <div className="content">

            {contents}

        </div>;
    }

    // Returns the HTML Form to the render() method.

    private renderForm(InformacionFamiliarDataList: InformacionFamiliarData[], parentescoList, sexoList: Array<any>, nivelInstruccionList: Array<any>, tipoDiscapacidadList: Array<any>, tiposEvidencia: Array<any>, estado: InformacionFamiliarDataState) {
        return (
            <>
                <Row>
                    <Col md={12}>
                        <Card className="principal">
                            <CardHeader>
                                <h5 className="title">INFORMACIÓN DEL NÚCLEO FAMILIAR</h5>
                            </CardHeader>
                            <CardBody className="main-content">
                                <div className={"new-alert-warn mb-1"}>
                                    <div>
                                        <button onClick={() => {
                                            const myAbsolutelyNotNullElement1 = window.document.getElementById('infogp');
                                            if (myAbsolutelyNotNullElement1 !== null && myAbsolutelyNotNullElement1.style.display === "none") {
                                                myAbsolutelyNotNullElement1.style.display = 'block';
                                            }
                                            else if (myAbsolutelyNotNullElement1 !== null && myAbsolutelyNotNullElement1.style.display === "block") {
                                                myAbsolutelyNotNullElement1.style.display = 'none';
                                            }
                                        }}>
                                            <img src={Megafono} className="icono_imagen " />&nbsp;Normas para la aplicación de la rebaja del impuesto a la renta por concepto de gastos personales <br />
                                        </button>
                                    </div>
                                    <div id="infogp" style={{ display: "none" }}>
                                        {MensajeEncabezadoCargasFamiliares}
                                    </div>
                                </div>
                                <br />
                                <div>
                                    <form onSubmit={(e) => this.handleSave(e, estado)} id="formTelefonos">
                                        <Row form>
                                            <Col md={2} sm={12} xs={12}>
                                                <FormGroup>
                                                    <Label for="tipoidentificacion">Tipo de identificación*</Label>
                                                    <SelectItem
                                                        options={tiposIdentificacion}
                                                        value={this.state.dtoData.tipoidentificacion}
                                                        onChange={this.handleSelectChange}
                                                        placeholder=""
                                                        name="tipoidentificacion"
                                                        id="tipoidentificacion"
                                                        icon="fa-caret-right"
                                                    />
                                                </FormGroup>
                                                {
                                                    //<FormGroup>
                                                    //    <div className="row" >
                                                    //        <div className="col-md-5">
                                                    //            <Label for="tipoidentificacion">Cédula</Label>
                                                    //            <CustomInput
                                                    //                className="col-md-5 ml-1"
                                                    //                type="radio"
                                                    //                checked={this.state.dtoData.tipoidentificacion === "CED"}
                                                    //                value="CED"
                                                    //                id="tipoidentificacion"
                                                    //                name="tipoidentificacion"
                                                    //                onChange={this.handleChange}
                                                    //                label=""
                                                    //            />
                                                    //        </div>
                                                    //        <div className="col-md-5">
                                                    //            <Label for="tipoidentificacion">Pasaporte</Label>
                                                    //            <CustomInput
                                                    //                className="col-md-6"
                                                    //                type="radio"
                                                    //                value="PAS"
                                                    //                id="tipoidentificacion2"
                                                    //                name="tipoidentificacion"
                                                    //                checked={this.state.dtoData.tipoidentificacion === "PAS"}
                                                    //                onChange={this.handleChange}
                                                    //                label=""
                                                    //            />
                                                    //        </div>
                                                    //    </div>
                                                    //</FormGroup>
                                                }
                                            </Col>
                                            <Col md={2} sm={12} xs={12}>
                                                <FormGroup>
                                                    <Label for="numeroidentificacion">Identificación*</Label>
                                                    <Input type="text" maxLength="10" name="numeroidentificacion" id="numeroidentificacion" value={this.state.dtoData.numeroidentificacion} onChange={this.handleChange} required />
                                                </FormGroup>
                                            </Col>
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="nombres">Nombres*</Label>
                                                    <Input type="text" maxLength="50" name="nombres" id="nombres" value={this.state.dtoData.nombres} onChange={this.handleChange} required readOnly={this.state.dtoData.tipoidentificacion === "CED" || this.state.readOnlyDatos ? true : false} />
                                                </FormGroup>
                                            </Col>
                                            {
                                                <Col md={3}>
                                                    <FormGroup>
                                                        <Label for="apellidos">Apellidos*</Label>
                                                        <Input type="text" maxLength="50" name="apellidos" id="apellidos" value={this.state.dtoData.apellidos} onChange={this.handleChange} required readOnly={this.state.dtoData.tipoidentificacion === "CED" || this.state.readOnlyDatos ? true : false} />
                                                    </FormGroup>
                                                </Col>
                                            }

                                            <Col md={2}>
                                                <FormGroup>
                                                    <Label for="fechanacimiento">F. nacimiento*</Label>
                                                    <Datepicker
                                                        value={this.state.dtoData.fechanacimiento}
                                                        name="fechanacimiento"
                                                        id="fechanacimiento"
                                                        onChange={this.handleSelectChange}
                                                        disabled={this.state.dtoData.tipoidentificacion === "CED" || this.state.readOnlyDatos ? true : false}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row form>

                                            <Col md={2}>
                                                <FormGroup>
                                                    <Label for="sexo">Sexo*</Label>
                                                    <SelectItem
                                                        options={sexoList}
                                                        value={this.state.dtoData.sexo}
                                                        onChange={this.handleSelectChange}
                                                        placeholder=""
                                                        name="sexo"
                                                        id="sexo"
                                                        icon="sexo"
                                                        disabled={this.state.dtoData.tipoidentificacion === "CED" || this.state.readOnlyDatos ? true : false}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md={3}>
                                                <FormGroup>
                                                    <Label for="exampleZip">Parentesco*</Label>
                                                    <SelectItem
                                                        options={parentescoList}
                                                        value={this.state.dtoData.idparentesco}
                                                        onChange={this.handleSelectChange}
                                                        placeholder=""
                                                        name="idparentesco"
                                                        id="idparentesco"
                                                        icon="parentesco"
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col md={(this.state.dtoData.idparentesco === 20 ? 5 : 4)}>
                                                <FormGroup>
                                                    <Label for="idcatalnivelinstruccion">Nivel de instrucción*</Label>
                                                    <SelectItem
                                                        options={nivelInstruccionList}
                                                        value={this.state.dtoData.idcatalnivelinstruccion}
                                                        onChange={this.handleSelectChange}
                                                        placeholder=""
                                                        name="idcatalnivelinstruccion"
                                                        id="idcatalnivelinstruccion"
                                                        icon="nivel_instruccion"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            {
                                                this.state.dtoData.idparentesco === 20 ?
                                                    <Col md={(this.state.dtoData.idparentesco === 20 ? 2 : 3)}>
                                                        <FormGroup>
                                                            <Label for="estudiaencopol">Estudia en COPOL*</Label>
                                                            <div className="row ml-1">
                                                                <CustomInput
                                                                    className="col-md-5"
                                                                    type="radio"
                                                                    value="S"
                                                                    id="estudiaencopol"
                                                                    checked={this.state.dtoData.estudiaencopol === "S"}
                                                                    name="estudiaencopol"
                                                                    onChange={this.handleChange}
                                                                    label="Sí" />
                                                                <CustomInput
                                                                    className="col-md-5"
                                                                    type="radio"
                                                                    value="N"
                                                                    id="estudiaencopol2"
                                                                    checked={this.state.dtoData.estudiaencopol === "N"}
                                                                    name="estudiaencopol"
                                                                    onChange={this.handleChange}
                                                                    label="No" />
                                                            </div>
                                                        </FormGroup>
                                                    </Col>
                                                    :
                                                    null
                                            }

                                            <Col md={3}>
                                                <Label for="exampleZip">Cédula de Familiar (PDF)*</Label>
                                                <FormGroup row>
                                                    {
                                                        //<Col sm={(this.descargarEvidencias(this.state.dtoData).length > 0 ? 9 : 12)} >
                                                        //    <FileUpload id="evidencias" icon="upload" placeholder="Evidencias sustento"
                                                        //        options={tiposEvidencia} onChange={this.handleFileUploadChange} values={this.state.filesData} />
                                                        //</Col>
                                                        //<FileDownload style={{ backgroundColor: "#517ED3" }} files={this.descargarEvidencias(this.state.dtoData)} icon="download" />
                                                    }

                                                    <Col md={(this.descargarEvidencias(this.state.dtoData).length > 0 ? 10 : 12)}>
                                                        <InputFileUpload
                                                            icon="upload"
                                                            onChange={this.handleFileUploadChange}
                                                            name="PAR"
                                                            placeholder={this.state.dtoData.refarchivodoc1 ? "Actualizar identificación de familiar" : "Subir identificación de familiar"}
                                                            required={true}
                                                            stateFile={this.state.filesData[0] !== undefined}
                                                        />

                                                    </Col>
                                                    <InputFileDownload tipo="identificación de familiar"
                                                        id="downloadRef1"
                                                        refarchivo={this.state.dtoData.refarchivodoc1}
                                                        name={"DOCUMENTO-" + this.state.dtoData.numeroidentificacion + ".PDF"}
                                                        url={API_URL + "InformacionFamiliar/Refarchivo/PAR/" + this.state.dtoData.iddependientepersona}
                                                    />
                                                </FormGroup>
                                            </Col>

                                        </Row>

                                        <Row form>

                                            <Col md={2}>
                                                <FormGroup>
                                                    <Label for="fechacaducidad">F. caducidad*</Label>
                                                    <Datepicker
                                                        value={this.state.dtoData.fechacaducidad}
                                                        name="fechacaducidad"
                                                        id="fechacaducidad"
                                                        onChange={this.handleSelectChange}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            {
                                                tipoCargasFamiliares.includes(this.state.dtoData.idparentesco) ?
                                                    <Col md={2}>
                                                        <FormGroup>
                                                            <Label for="considerargp">¿Considerar carga familiar para rebaja de gastos personales?*</Label>
                                                            <div className="row ml-1" >
                                                                <CustomInput
                                                                    className="col-md-5"
                                                                    type="radio"
                                                                    checked={this.state.dtoData.considerargp === "S"}
                                                                    value="S"
                                                                    id="escargafamiliar"
                                                                    name="considerargp"
                                                                    onChange={this.handleChange}
                                                                    label="Sí"

                                                                />
                                                                <CustomInput
                                                                    className="col-md-6"
                                                                    type="radio"
                                                                    value="N"
                                                                    id="escargafamiliar2"
                                                                    name="considerargp"
                                                                    checked={this.state.dtoData.considerargp === "N"}
                                                                    onChange={this.handleChange}
                                                                    label="No"

                                                                />
                                                            </div>
                                                        </FormGroup>
                                                    </Col>
                                                    : ""
                                            }
                                            {
                                                ((this.state.dtoData.idparentesco == 1 || this.state.dtoData.idparentesco == 2) && this.state.dtoData.considerargp == "S") ?
                                                    <Col md={3}>
                                                        <Label for="">Consentimiento expreso para ser incluidos como carga familiar (PDF)*</Label>
                                                        <FormGroup row>
                                                            <Col md={(this.descargarEvidencias(this.state.dtoData).length > 0 ? 10 : 12)}>
                                                                <InputFileUpload
                                                                    icon="upload"
                                                                    onChange={this.handleFileUploadChange}
                                                                    name="CCF"
                                                                    placeholder={this.state.dtoData.refarchivoconsentimiento ? "Actualizar documento" : "Subir documento"}
                                                                    required={true}
                                                                    stateFile={this.state.filesData[0] !== undefined}
                                                                />
                                                            </Col>
                                                            <InputFileDownload tipo="Consentimiento expreso para ser incluidos como carga familiar"
                                                                id="refarchivoconsentimiento"
                                                                refarchivo={this.state.dtoData.refarchivoconsentimiento}
                                                                name={"DOCUMENTO-" + this.state.dtoData.numeroidentificacion + ".PDF"}
                                                                url={API_URL + "InformacionFamiliar/Refarchivo/CCF/" + this.state.dtoData.iddependientepersona}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    : ""
                                            }
                                            <Col md={2}>
                                                <FormGroup>
                                                    <Label for="tieneenfercatastrofica">¿Padece una enfermedad catastrófica, rara y/o huérfana?*</Label>
                                                    <div className="row ml-1" >
                                                        <CustomInput
                                                            className="col-md-5"
                                                            type="radio"
                                                            checked={this.state.dtoData.tieneenfercatastrofica === "S"}
                                                            value="S"
                                                            id="tieneenfercatastrofica"
                                                            name="tieneenfercatastrofica"
                                                            onChange={this.handleChange}
                                                            label="Sí"

                                                        />
                                                        <CustomInput
                                                            className="col-md-6"
                                                            type="radio"
                                                            value="N"
                                                            id="tieneenfercatastrofica2"
                                                            name="tieneenfercatastrofica"
                                                            checked={this.state.dtoData.tieneenfercatastrofica === "N"}
                                                            onChange={this.handleChange}
                                                            label="No"

                                                        />
                                                    </div>
                                                </FormGroup>
                                            </Col>
                                            {
                                                (this.state.dtoData.tieneenfercatastrofica == "S") ?
                                                    <Col md={3}>
                                                        <Label for="">Certificado o aval de padecer una enfermedad catastrófica, rara y/o huérfana (PDF)*</Label>
                                                        <FormGroup row>
                                                            <Col md={(this.descargarEvidencias(this.state.dtoData).length > 0 ? 10 : 12)}>
                                                                <InputFileUpload
                                                                    icon="upload"
                                                                    onChange={this.handleFileUploadChange}
                                                                    name="ENC"
                                                                    placeholder={this.state.dtoData.refarchivoenfercatastrofica ? "Actualizar documento" : "Subir documento"}
                                                                    required={true}
                                                                    stateFile={this.state.filesData[0] !== undefined}
                                                                />
                                                            </Col>
                                                            <InputFileDownload tipo="Certificado o aval de padecer una enfermedad catastrófica, rara y/o huérfana"
                                                                id="refarchivoenfercatastrofica"
                                                                refarchivo={this.state.dtoData.refarchivoenfercatastrofica}
                                                                name={"DOCUMENTO-" + this.state.dtoData.numeroidentificacion + ".PDF"}
                                                                url={API_URL + "InformacionFamiliar/Refarchivo/ENC/" + this.state.dtoData.iddependientepersona}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    : ""
                                            }
                                        </Row>

                                        {
                                            //<br />
                                            //<span style={{ color: "#547BBD", display: "inline", fontStyle: "italic" }}>DATOS DE DISCAPACIDAD</span>
                                        }

                                        <Row form>
                                            <Col md={2}>
                                                <FormGroup>
                                                    <Label for="esincapacitado">¿Su familiar presenta discapacidad?*</Label>
                                                    <div className="row ml-1" >
                                                        <CustomInput
                                                            className="col-md-5"
                                                            type="radio"
                                                            checked={this.state.dtoData.esincapacitado === "S"}
                                                            value="S"
                                                            id="esincapacitado"
                                                            name="esincapacitado"
                                                            onChange={this.handleChange}
                                                            label="Sí"
                                                            disabled={this.state.webServiceFuncional}
                                                        />
                                                        <CustomInput
                                                            className="col-md-6"
                                                            type="radio"
                                                            value="N"
                                                            id="esincapacitado2"
                                                            name="esincapacitado"
                                                            checked={this.state.dtoData.esincapacitado === "N"}
                                                            onChange={this.handleChange}
                                                            label="No"
                                                            disabled={this.state.webServiceFuncional}
                                                        />
                                                    </div>
                                                </FormGroup>
                                            </Col>
                                            {this.state.dtoData.esincapacitado === "S" && (!this.state.webServiceFuncional || (this.state.webServiceFuncional && this.state.dtoData.discapcarnet)) ?
                                                <>
                                                    <Col md={3}>
                                                        <FormGroup>
                                                            <Label for="discaptipo">Tipo de discapacidad*</Label>
                                                            <SelectItem
                                                                options={tipoDiscapacidadList}
                                                                value={this.state.dtoData.discaptipo}
                                                                onChange={this.handleSelectChange}
                                                                placeholder=""
                                                                name="discaptipo"
                                                                id="discaptipo"
                                                                icon="discapacidad"
                                                                disabled={this.state.webServiceFuncional}
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={2}>
                                                        <FormGroup>
                                                            <Label for="discapporc">Porcentaje*</Label>
                                                            <InputGroup>
                                                                <Input type="number" readOnly={this.state.webServiceFuncional} value={this.state.dtoData.discapporc} name="discapporc" onChange={this.handleChange} required />
                                                                <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
                                                                    <i className="fas fa-percent" aria-hidden="true"></i>
                                                                </InputGroupAddon>
                                                            </InputGroup>
                                                        </FormGroup>
                                                    </Col>
                                                    {/* <Col md={2}>
                                                        <FormGroup>
                                                            <Label for="discapcarnet"># Carnet conadis*</Label>
                                                            <InputGroup>
                                                                <Input type="text" readOnly={this.state.webServiceFuncional} value={this.state.dtoData.discapcarnet} name="discapcarnet" onChange={this.handleChange} required />
                                                                <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
                                                                    <i className="fas fa-hashtag" aria-hidden="true"></i>
                                                                </InputGroupAddon>
                                                            </InputGroup>

                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={3}>
                                                        <FormGroup>
                                                            <Label for="fechaemisiondiscap">F. emisión*</Label>
                                                            <Datepicker
                                                                value={this.state.dtoData.fechaemisiondiscap}
                                                                name="fechaemisiondiscap"
                                                                id="fechaemisiondiscap"
                                                                onChange={this.handleSelectChange}
                                                                disabled={this.state.webServiceFuncional}
                                                            />
                                                        </FormGroup>
                                                    </Col> */}
                                                    <Col md={2}>
                                                        <FormGroup>
                                                            <Label for="fechacaducidaddiscap">F. caducidad*</Label>
                                                            <Datepicker
                                                                value={this.state.dtoData.fechacaducidaddiscap}
                                                                name="fechacaducidaddiscap"
                                                                id="fechacaducidaddiscap"
                                                                onChange={this.handleSelectChange}
                                                                disabled={this.state.webServiceFuncional}
                                                            />

                                                        </FormGroup>
                                                    </Col>
                                                    {/* <Col md={3}>
                                                        <Label for="exampleZip">Evidencia*</Label>
                                                        <FormGroup row>
                                                            <Col md={(this.descargarEvidencias(this.state.dtoData).length > 0 ? 10 : 12)}>
                                                                <InputFileUpload
                                                                    icon="upload"
                                                                    onChange={this.handleFileUploadChange}
                                                                    name="FDS"
                                                                    placeholder={this.state.dtoData.refarchivo ? "Actualizar carnet CONADIS" : "Subir carnet CONADIS"} />
                                                            </Col>
                                                            <InputFileDownload tipo="carnet CONADIS"
                                                                id="downloadRef"
                                                                refarchivo={this.state.dtoData.refarchivo}
                                                                name={"DE-" + this.state.dtoData.numeroidentificacion + ".PDF"}
                                                                url={API_URL + "InformacionFamiliar/Refarchivo/FDS/" + this.state.dtoData.iddependientepersona}
                                                            />
                                                        </FormGroup>
                                                    </Col> */}
                                                </>
                                                : null}

                                            {/* {this.state.dtoData.idpersona !== 0 ?
                                                <Col md={this.state.dtoData.esincapacitado === "S"? 7 : 10}>
                                                    <FormGroup>
                                                        <Button id="actualizarInfoBtn" color="primary" type="button" className="btn btn-default" style={{ float: "right" }} onClick={() => this.buscarPersona(this.state.dtoData.numeroidentificacion)}>Actualizar información desde Registro Civil</Button>
                                                        <TooltipItem content="Para actualizar la información, ingrese el número de identificación" id="actualizarInfoBtn" />
                                                    </FormGroup>
                                                </Col>
                                                :
                                                null
                                            } */}

                                            {/* {this.state.dtoData.esincapacitado === "S" && this.state.dtoData.discapcarnet?
                                                <>
                                                    <Col md={12} className="mt-4">
                                                        <span style={{ color: "#547BBD", display: "inline", fontStyle: "italic" }}>DATOS DE SUSTITUCIÓN</span>
                                                    </Col>
                                                    <Col md={2}>
                                                        <FormGroup>
                                                            <Label for="essustitutolegal">¿Ha sido declarado empleado sustituto?*</Label>
                                                            <div className="row ml-1" >
                                                                <CustomInput
                                                                    className="col-md-5"
                                                                    type="radio"
                                                                    value="S"
                                                                    id="essustitutolegal"
                                                                    checked={this.state.dtoData.essustitutolegal === "S"}
                                                                    name="essustitutolegal"
                                                                    onChange={this.handleChange}
                                                                    label="Sí" />
                                                                <CustomInput
                                                                    className="col-md-5"
                                                                    type="radio"
                                                                    value="N"
                                                                    id="essustitutolegal2"
                                                                    checked={this.state.dtoData.essustitutolegal === "N"}
                                                                    name="essustitutolegal"
                                                                    onChange={this.handleChange}
                                                                    label="No" />
                                                            </div>
                                                        </FormGroup>
                                                    </Col>
                                                    {this.state.dtoData.essustitutolegal === "S" ?
                                                        <>
                                                            <Col md={3}>
                                                                <FormGroup>
                                                                    <Label for="discapcarnet"># de la certificación*</Label>
                                                                    <InputGroup>
                                                                        <Input type="text" maxLength="50" value={this.state.dtoData.numerocertsustituto} name="numerocertsustituto" onChange={this.handleChange} required />
                                                                        <InputGroupAddon addonType="append" style={{ backgroundColor: "#FFC200" }}>
                                                                            <i className="fas fa-hashtag" aria-hidden="true"></i>
                                                                        </InputGroupAddon>
                                                                    </InputGroup>

                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={2}>
                                                                <FormGroup>
                                                                    <Label for="fechaemisioncertsustituto">F. emisión certificación*</Label>
                                                                    <Datepicker
                                                                        value={this.state.dtoData.fechaemisioncertsustituto}
                                                                        name="fechaemisioncertsustituto"
                                                                        id="fechaemisioncertsustituto"
                                                                        onChange={this.handleSelectChange}
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={2}>
                                                                <FormGroup>
                                                                    <Label for="fechacaducidadcertsustituto">F. caducidad certificación</Label>
                                                                    <Datepicker
                                                                        value={this.state.dtoData.fechacaducidadcertsustituto}
                                                                        name="fechacaducidadcertsustituto"
                                                                        id="fechacaducidadcertsustituto"
                                                                        onChange={this.handleSelectChange}
                                                                    />

                                                                </FormGroup>
                                                            </Col>
                                                        </>
                                                        :
                                                        null
                                                    }
                                                </>
                                                :
                                                null
                                            }

                                            {this.state.dtoData.essustitutolegal === "S" && this.state.dtoData.discapcarnet ?
                                                <Col md={3}>
                                                    <Label for="exampleZip">Evidencia 3</Label>
                                                    <FormGroup row>
                                                        <Col md={(this.descargarEvidencias(this.state.dtoData).length > 0 ? 10 : 12)}>
                                                            <InputFileUpload
                                                                icon="upload"
                                                                onChange={this.handleFileUploadChange}
                                                                name="FDS"
                                                                placeholder={this.state.dtoData.refarchivodoc4 ? "Actualizar documento del ministerio de trabajo" : "Subir documento del ministerio de trabajo"} />
                                                        </Col>
                                                        <InputFileDownload tipo="documento del ministerio de trabajo"
                                                            id="downloadRef4"
                                                            refarchivo={this.state.dtoData.refarchivodoc4}
                                                            name={"DE" + this.state.dtoData.numeroidentificacion + ".PDF"}
                                                            url={API_URL + "InformacionFamiliar/Refarchivo/TRA/" + this.state.dtoData.iddependientepersona}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                : null}

                                        */}

                                        </Row>

                                        {this.state.dtoData.esincapacitado === "S" ?
                                            <Row form>

                                                <FormGroup check>
                                                    <Label check>
                                                        {/* <Input name="autorizacion" type="checkbox" onChange={this.toggleCheckbox} />{' '} */}
                                                        {/* La información referente a discapacidad se actualiza de manera automática cada 3 meses y se encuentra interrelacionada con la base del Ministerio de Salud */}
                                                    </Label>
                                                    {/* {this.state.dtoData.essustitutolegal === "S" ? */}
                                                        <Label check>
                                                        <Input name="autorizacion" checked={this.state.autorizacion} type="checkbox" onChange={this.toggleCheckbox} />{' '}
                                                                Declaro que los datos aquí ingresados, son verdaderos y es de mi entera responsabilidad la veracidad de los mismos, y autorizo a la ESPOL,
                                                                en caso de ser necesario para que pueda comprobar por todos los medios legales la veracidad de mi información consignada en el sistema.
                                                        </Label>
                                                        {/* :
                                                        null
                                                    } */}
                                                </FormGroup>

                                            </Row>
                                            :
                                            null
                                        }

                                        <br />

                                        <Row form>
                                            <Col md={12}>
                                                <FormGroup>
                                                    <Button color="primary" type="button" className="btn btn-default" style={{ float: "right" }} onClick={() => this.onClickLimpiar()}>Limpiar</Button>
                                                    <Button color="secondary" type="submit" className="btn btn-default" style={{ float: "right" }}>Guardar</Button>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </form >
                                </div>
                                <br />
                                <div>
                                    {(this.state.loadingList ?
                                        <div style={{ textAlign: "center" }}>
                                            <i className="fas fa-sync fa-spin"></i>
                                            <em> Cargando</em>

                                        </div>
                                        :
                                        <Row id="lista">
                                            {InformacionFamiliarDataList.map((dto, index) =>
                                                <CardInformacionFamiliar
                                                    key={dto.iddependientepersona}
                                                    objeto={dto}
                                                    evidencias={this.descargarEvidencias(dto)}
                                                    number={(index + 1) + " / " + InformacionFamiliarDataList.length}
                                                    eventEdit={() => this.onClickEdit(dto.iddependientepersona)}
                                                    eventDelete={() => this.onClickDelete(dto.iddependientepersona)} />
                                            )}
                                        </Row>
                                    )}
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

            </>
        );
    }
}

export default InformacionFamiliar;